/* eslint-disable max-len */
import {conditionType} from '../../../../../pages/esgManager/interface/inputType';
import {
  createRowDatePickerField,
  createRowMultiSelectField,
  createRowNumberField,
  createRowSelectField,
  createRowWysiwygField,
  createTableQuestion,
  createTableWithFixedRowsQuestion
} from '../../../Utils/questionHelper';

import {
  ASSET_CLASSES_COVERED_BY_THE_TARGET_OPTIONS,
  COMMODITY_VALUE_CHAIN_STAGE_COVERAGE_OPTIONS,
  DISCLOSER_METRIC_OPTIONS,
  EMISSIONS_CALCULATION_METHODOLOGY_GHG_OPTIONS,
  ENVIRONMENTAL_ISSUES_OPTIONS,
  INDUSTRY_SECTORS_OPTIONS,
  METRIC_TYPE_OPTIONS,
  MITIGATION_ADAPTATION_OPTIONS,
  NATURE_TARGET_SETTING_REFERENCES_OPTIONS,
  PLAN_TO_DO_OPTIONS,
  PORTFOLIO_BREAKDOWN_OPTIONS,
  PORTFOLIO_METRIC_OPTIONS,
  PORTFOLIO_METRIC_UNIT_OPTIONS,
  PORTFOLIOS_COVERED_BY_THE_TARGET_OPTIONS,
  PRIMARY_REASON_FOR_NO_PLANS_TO_DEVELOP_CAPABILITIES_TO_ALLOCATE_EMISSIONS_TO_CUSTOMERS_OPTIONS,
  PRIMARY_REASON_FOR_NOT_PROVIDING_VALUES_OPTIONS,
  REPORTING_VALUES_OF_FINANCING_OPTIONS,
  SCOPES_OPTIONS,
  TARGET_SET_FULL_OPTIONS,
  TARGET_SET_OPTIONS,
  TAXONOMY_OR_FRAMEWORK_USED_TO_DEFINE_GREEN_FINANCE_OPTIONS,
  TAXONOMY_OR_METHODOLOGY_OPTIONS,
  TYPE_OF_PRODUCT_CLASSIFICATION_OPTIONS,
  TYPE_OF_SOLUTION_FINANCED_INVESTED_INSURED_OPTIONS,
  YES_NO_NOT_APPLICABLE_OPTIONS,
  YES_NO_OPTIONS,
  YES_NO_UNKNOWN_OPTIONS
} from './corporateOptions';
import {CDP_FINANCIAL_SERVICES_KEYS} from './corporateQuestionsKeys';

export const environmentalPerformanceFinancialServicesQuestions = [
  {
    key: 'Q1',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_FINANCIAL_SERVICES_KEYS.Q1_VALUE,
        '12.1 Does your organization measure the impact of your portfolio on the environment?',
        'Most of financial institutions’ impact on the environment occurs in their portfolios, within the financial products and services they provide and/or in their investments that enable activities which have impact on the environment. Organizations in this sector should measure their portfolio impact using specific metrics to understand the impact their financial activities have on the environment and manage it properly. This question informs investors and other data users about the extent to which organizations understand their portfolios’ environmental impact.',
        'Portfolio',
        [
          {id: 'Banking (Bank)', label: 'Banking (Bank)'},
          {id: 'Investing (Asset manager)', label: 'Investing (Asset manager)'},
          {id: 'Investing (Asset owner)', label: 'Investing (Asset owner)'},
          {
            id: 'Insurance underwriting (Insurance company)',
            label: 'Insurance underwriting (Insurance company)'
          }
        ],
        [
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q1_1_VALUE,
            'We measure the impact of our portfolio on the climate',
            PLAN_TO_DO_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q1_2_VALUE,
            'Disclosure metric',
            DISCLOSER_METRIC_OPTIONS,
            true,
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q1_1_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q1_1_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q1_3_VALUE,
            'Primary reason for not measuring portfolio impact on climate',
            PRIMARY_REASON_FOR_NO_PLANS_TO_DEVELOP_CAPABILITIES_TO_ALLOCATE_EMISSIONS_TO_CUSTOMERS_OPTIONS,
            true,
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q1_1_VALUE,
              condition: conditionType.NOT,
              values: [
                'No, but we plan to do so in the next two years',
                'No, and we do not plan to do so in the next two years'
              ]
            },
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q1_1_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'No, but we plan to do so in the next two years',
                'No, and we do not plan to do so in the next two years'
              ],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q1_4_VALUE,
            'Explain why your organization does not measure its portfolio impact on climate',
            2500,
            undefined,
            undefined,
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q1_1_VALUE,
              condition: conditionType.NOT,
              values: [
                'No, but we plan to do so in the next two years',
                'No, and we do not plan to do so in the next two years'
              ]
            },
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q1_1_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'No, but we plan to do so in the next two years',
                'No, and we do not plan to do so in the next two years'
              ],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q1_5_VALUE,
            'We measure the impact of our portfolio on forests',
            PLAN_TO_DO_OPTIONS
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q1_6_VALUE,
            'Primary reason for not measuring portfolio impact on forests',
            PRIMARY_REASON_FOR_NO_PLANS_TO_DEVELOP_CAPABILITIES_TO_ALLOCATE_EMISSIONS_TO_CUSTOMERS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q1_7_VALUE,
            'Explain why your organization does not measure its portfolio impact on forests',
            2500,
            undefined,
            undefined,
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q1_5_VALUE,
              condition: conditionType.NOT,
              values: [
                'No, but we plan to do so in the next two years',
                'No, and we do not plan to do so in the next two years'
              ]
            },
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q1_5_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'No, but we plan to do so in the next two years',
                'No, and we do not plan to do so in the next two years'
              ],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q1_8_VALUE,
            'We measure the impact of our portfolio on water',
            PLAN_TO_DO_OPTIONS
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q1_9_VALUE,
            'Primary reason for not measuring portfolio impact on water',
            PRIMARY_REASON_FOR_NO_PLANS_TO_DEVELOP_CAPABILITIES_TO_ALLOCATE_EMISSIONS_TO_CUSTOMERS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q1_10_VALUE,
            'Explain why your organization does not measure its portfolio impact on water',
            2500
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q1_11_VALUE,
            'We measure the impact of our portfolio on biodiversity',
            PLAN_TO_DO_OPTIONS
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q1_12_VALUE,
            'Primary reason for not measuring portfolio impact on biodiversity',
            PRIMARY_REASON_FOR_NO_PLANS_TO_DEVELOP_CAPABILITIES_TO_ALLOCATE_EMISSIONS_TO_CUSTOMERS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q1_13_VALUE,
            'Explain why your organization does not measure its portfolio impact on biodiversity',
            2500,
            undefined,
            undefined,
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q1_11_VALUE,
              condition: conditionType.NOT,
              values: [
                'No, but we plan to do so in the next two years',
                'No, and we do not plan to do so in the next two years'
              ]
            },
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q1_11_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'No, but we plan to do so in the next two years',
                'No, and we do not plan to do so in the next two years'
              ],
              required: true
            }
          )
        ]
      )
    ]
  },
  {
    key: 'Q2',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_FINANCIAL_SERVICES_KEYS.Q2_VALUE,
        `12.1.1 Provide details of your ${'organization'}'s financed emissions in the reporting year and in the base year.`,
        'GHG emissions accounting is one of the primary metrics organizations in the financial sector can use to understand how their portfolio impacts the climate. In addition to highlighting risks and opportunities, portfolio emissions disclosure is a pre-requisite for financial institutions to measure improvements in the climate performance of their portfolios, and measure progress towards the net zero commitments that are increasingly being made. IMPORTANT NOTE: This question asks you to disclose your financed emissions (also known as Scope 3 Category 15 “Investments” total absolute emissions). For organizations in the financial sector, Scope 3 Category 15 “Investments” total absolute emissions has been pulled out of question 7.8 as the majority of emissions occur in the investment chain, in relation to financial products and services and/or investments. Portfolio emissions (or Scope 3 Category 15 “Investments” total absolute emissions as defined by the GHG Protocol) is the most relevant category to financial services organizations. In this question, organizations in the financial sector are only requested to disclose their Scope 3 Category 15 “Investments” total absolute emissions, Categories 1-14 and if applicable other upstream or downstream scope 3 emissions should be disclosed in 7.8.',
        'Portfolio',
        [
          {id: 'Banking (Bank)', label: 'Banking (Bank)'},
          {id: 'Investing (Asset manager)', label: 'Investing (Asset manager)'},
          {id: 'Investing (Asset owner)', label: 'Investing (Asset owner)'},
          {
            id: 'Insurance underwriting (Insurance company)',
            label: 'Insurance underwriting (Insurance company)'
          }
        ],
        [
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q2_1_VALUE,
            'Asset classes covered in the calculation',
            ASSET_CLASSES_COVERED_BY_THE_TARGET_OPTIONS
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q2_2_VALUE,
            'Financed emissions (metric unit tons CO2e) in the reporting year',
            3
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q2_3_VALUE,
            '% of portfolio covered in relation to total portfolio value'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q2_4_VALUE,
            'Total value of assets included in the financed emissions calculation [Auto-calculated]'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q2_5_VALUE,
            '% of financed emissions calculated using data obtained from clients/investees (optional)'
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q2_6_VALUE,
            'Emissions calculation methodology',
            EMISSIONS_CALCULATION_METHODOLOGY_GHG_OPTIONS
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q2_7_VALUE,
            'Weighted data quality score (for PCAF-aligned data quality scores only)',
            3
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q2_8_VALUE,
            'Financed emissions (metric unit tons CO2e) in the base year',
            3
          ),
          createRowDatePickerField(
            CDP_FINANCIAL_SERVICES_KEYS.Q2_9_VALUE,
            'Base year end'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q2_10_VALUE,
            '% of undrawn loan commitments included in the financed emissions calculation'
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q2_11_VALUE,
            'Please explain the details of and assumptions used in your calculation',
            2500
          )
        ]
      )
    ]
  },
  {
    key: 'Q3',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_FINANCIAL_SERVICES_KEYS.Q3_VALUE,
        '12.1.2 Disclose or restate your financed emissions for previous years.',
        'A prerequisite for a meaningful emissions data comparison is a consistent dataset over time. This question enables organizations to restate portfolio emissions data previously supplied to CDP, for example to ensure that their historical data reflects their current organizational boundary. It also allows first-time responders to provide portfolio emissions data for the five years prior to the reporting year. ',
        'Year',
        [
          {
            label: 'Past year 1 for Banking (Bank)',
            id: 'Past year 1 for Banking (Bank)'
          },
          {
            label: 'Past year 1 for Investing (Asset manager)',
            id: 'Past year 1 for Investing (Asset manager)'
          },
          {
            label: 'Past year 1 for Investing (Asset owner)',
            id: 'Past year 1 for Investing (Asset owner)'
          },
          {
            label: 'Past year 1 for Insurance underwriting (Insurance company)',
            id: 'Past year 1 for Insurance underwriting (Insurance company)'
          },
          {
            label: 'Years 2 to 4 continue…',
            id: 'Years 2 to 4 continue…'
          },
          {
            label: 'Past year 5 for Banking (Bank)',
            id: 'Past year 5 for Banking (Bank)'
          },
          {
            label: 'Past year 5 for Investing (Asset manager)',
            id: 'Past year 5 for Investing (Asset manager)'
          },
          {
            label: 'Past year 5 for Investing (Asset owner)',
            id: 'Past year 5 for Investing (Asset owner)'
          },
          {
            label: 'Past year 5 for Insurance underwriting (Insurance company)',
            id: 'Past year 5 for Insurance underwriting (Insurance company)'
          }
        ],
        [
          createRowDatePickerField(
            CDP_FINANCIAL_SERVICES_KEYS.Q3_1_VALUE,
            'End Date'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q3_2_VALUE,
            'Financed emissions (metric unit tons CO2e) in the reporting year',
            3
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q3_3_VALUE,
            '% of portfolio covered in relation to total portfolio value'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q3_4_VALUE,
            '% calculated using data obtained from clients/investees'
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q3_5_VALUE,
            'Emissions calculation methodology',
            EMISSIONS_CALCULATION_METHODOLOGY_GHG_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q3_6_VALUE,
            'Please explain the details of and assumptions used in your calculation',
            2500
          )
        ]
      )
    ]
  },
  {
    key: 'Q4',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FINANCIAL_SERVICES_KEYS.Q4_VALUE,
        '12.1.3 Provide details of the other metrics used to track the impact of your portfolio on the environment.',
        'This question acknowledges that in addition to GHG emissions accounting, there are a number of other metrics organizations in the financial sector can use to understand how their portfolio impacts the environment. Metrics for measuring portfolio impact on forests, water and biodiversity are in their infancy, so this question allows financial institutions to explain how they assess the impact of their portfolio on the environment. This question allows you to express the impact of your portfolio on the environment using other metrics identified by the TCFD or other leading environmental frameworks and standards. ',
        [
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q4_1_VALUE,
            'Environmental issue',
            ENVIRONMENTAL_ISSUES_OPTIONS
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q4_2_VALUE,
            'Portfolio',
            PORTFOLIOS_COVERED_BY_THE_TARGET_OPTIONS
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q4_3_VALUE,
            'Portfolio metric',
            PORTFOLIO_METRIC_OPTIONS
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q4_4_VALUE,
            'Metric value in the reporting year',
            3
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q4_5_VALUE,
            '% of portfolio covered in relation to total portfolio value'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q4_6_VALUE,
            'Total value of assets included in the calculation',
            3
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q4_7_VALUE,
            '% of emissions calculated using data obtained from clients/investees'
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q4_8_VALUE,
            'Please explain the details and key assumptions used in your assessment',
            3000
          )
        ],
        false,
        CDP_FINANCIAL_SERVICES_KEYS.Q1_VALUE,
        CDP_FINANCIAL_SERVICES_KEYS.Q1_1_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q5',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_FINANCIAL_SERVICES_KEYS.Q5_VALUE,
        `12.2 Are you able to provide a breakdown of your ${'organization'}'s financed emissions and other portfolio carbon footprint metrics?`,
        'By breaking down emissions and other carbon footprinting metrics by asset class, industry, and scope, this data can be made available to data users and other stakeholders to help guide the development of portfolio footprinting methodologies, global decarbonization efforts, and regional legislation.',
        'Portfolio',
        [
          {id: 'Banking (Bank)', label: 'Banking (Bank)'},
          {id: 'Investing (Asset manager)', label: 'Investing (Asset manager)'},
          {id: 'Investing (Asset owner)', label: 'Investing (Asset owner)'},
          {
            id: 'Insurance underwriting (Insurance company)',
            label: 'Insurance underwriting (Insurance company)'
          }
        ],
        [
          createRowMultiSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q5_1_VALUE,
            'Portfolio breakdown',
            PORTFOLIO_BREAKDOWN_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q5_2_VALUE,
            'Please explain why you do not provide a breakdown of your portfolio impact on the climate',
            2500
          )
        ]
      )
    ]
  },
  {
    key: 'Q6',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FINANCIAL_SERVICES_KEYS.Q6_VALUE,
        '12.2.1 Break down your organization’s financed emissions and other portfolio carbon footprinting metrics by asset class, by industry, and/or by scope.',
        'Current methodologies for calculating portfolio emissions can lead to double counting across scopes. Breaking down absolute emissions and/or other carbon footprinting metrics of a portfolio by scope can help financial institutions identify emissions throughout the value chain of companies in their portfolio. Reporting at this level can provide a useful indicator for making comparisons between your financial activities in different industries. Furthermore, breaking down emissions and other carbon footprinting and/or exposure metrics by asset class can give an indication of the relative GHG emissions performance and/or exposure to climate-related risks of your company’s assets. When reported over time, your organization and data users will be able to review improvements or declines in asset performance with considerations for your portfolio’s impact on the climate. ',
        [
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q6_1_VALUE,
            'Portfolio',
            PORTFOLIOS_COVERED_BY_THE_TARGET_OPTIONS
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q6_2_VALUE,
            'Portfolio metric',
            PORTFOLIO_METRIC_UNIT_OPTIONS
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q6_3_VALUE,
            'Industry',
            INDUSTRY_SECTORS_OPTIONS
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q6_4_VALUE,
            'Asset class',
            ASSET_CLASSES_COVERED_BY_THE_TARGET_OPTIONS
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q6_5_VALUE,
            'Clients’/investees’ scope',
            SCOPES_OPTIONS
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q6_6_VALUE,
            '% of asset class emissions calculated in the reporting year based on total value of assets',
            undefined,
            undefined,
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q6_4_VALUE,
              condition: conditionType.EMPTY,
              values: []
            }
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q6_7_VALUE,
            'Value of assets covered in the calculation',
            2
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q6_8_VALUE,
            'Financed emissions or alternative metric',
            2
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q6_9_VALUE,
            'Are you able to provide the gross exposure for your undrawn loan commitment separately from the drawn loan commitment?',
            YES_NO_NOT_APPLICABLE_OPTIONS
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q6_10_VALUE,
            'Value of assets covered in the calculation based on outstanding loan amounts',
            2
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q6_11_VALUE,
            'Value of assets covered in the calculation including undrawn loan commitments',
            2
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q6_12_VALUE,
            'Please explain the details, assumptions and exclusions in your calculation',
            3000
          )
        ],
        true
      )
    ]
  },
  {
    key: 'Q7',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_FINANCIAL_SERVICES_KEYS.Q7_VALUE,
        '12.3 State the values of your financing and insurance of fossil fuel assets in the reporting year.',
        'The majority of financial institutions’ emissions are driven by the activities they finance in the wider economy, also known as ‘financed emissions’. The exposure of financial institutions to climate-related risks and opportunities are determined by their portfolios via lending, investment and insurance underwriting activities. Therefore, data users wish to understand the concentrations of fossil fuel assets in financial institutions’ portfolios.',
        'Portfolio',
        [
          {
            id: 'portfolio1',
            label: 'Lending to all fossil fuel assets'
          },
          {id: 'portfolio2', label: 'Lending to thermal coal'},
          {id: 'portfolio3', label: 'Lending to met coal'},
          {id: 'portfolio4', label: 'Lending to oil'},
          {id: 'portfolio5', label: 'Lending to gas'},
          {
            id: 'portfolio6',
            label: 'Investing in all fossil fuel assets (Asset manager)'
          },
          {
            id: 'portfolio7',
            label: 'Investing in thermal coal (Asset manager)'
          },
          {
            id: 'portfolio8',
            label: 'Investing in met coal (Asset manager)'
          },
          {
            id: 'portfolio9',
            label: 'Investing in oil (Asset manager)'
          },
          {
            id: 'portfolio10',
            label: 'Investing in gas (Asset manager)'
          },
          {
            id: 'portfolio11',
            label: 'Investing in all fossil fuel assets (Asset owner)'
          },
          {
            id: 'portfolio12',
            label: 'Investing in thermal coal (Asset owner)'
          },
          {
            id: 'portfolio13',
            label: 'Investing in met coal (Asset owner)'
          },
          {
            id: 'portfolio14',
            label: 'Investing in oil (Asset owner)'
          },
          {
            id: 'portfolio15',
            label: 'Investing in gas (Asset owner)'
          },
          {
            id: 'portfolio16',
            label: 'Insuring all fossil fuel assets'
          },
          {id: 'portfolio17', label: 'Insuring thermal coal'},
          {id: 'portfolio18', label: 'Insuring met coal'},
          {id: 'portfolio19', label: 'Insuring oil'},
          {id: 'portfolio20', label: 'Insuring gas'}
        ],
        [
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q7_1_VALUE,
            'Reporting values of the financing and/or insurance of fossil fuel assets',
            REPORTING_VALUES_OF_FINANCING_OPTIONS
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q7_2_VALUE,
            'Value of the fossil fuel assets in your portfolio (unit currency - as specified in 1.2)',
            2,
            true,
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q7_1_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q7_1_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q7_3_VALUE,
            'New loans advanced in reporting year (unit currency - as specified in 1.2)',
            2,
            true,
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q7_1_VALUE_PORTFOLIO1,
              condition: conditionType.NOT,
              values: ['Yes'],
              rowIdPattern: [
                'portfolio1',
                'portfolio2',
                'portfolio3',
                'portfolio4',
                'portfolio5'
              ]
            },
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q7_1_VALUE_PORTFOLIO1,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true,
              rowIdPattern: [
                'portfolio1',
                'portfolio2',
                'portfolio3',
                'portfolio4',
                'portfolio5'
              ]
            }
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q7_4_VALUE,
            'Total premium written in reporting year (unit currency - as specified in 1.2)'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q7_5_VALUE,
            '% of portfolio value comprised of fossil fuel assets to total portfolio value in reporting year',
            1
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q7_6_VALUE,
            'Details of calculation',
            2500
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q7_7_VALUE,
            'Primary reason for not providing values of the financing and/or insurance to fossil fuel assets',
            PRIMARY_REASON_FOR_NOT_PROVIDING_VALUES_OPTIONS,
            true,
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q7_1_VALUE,
              condition: conditionType.NOT,
              values: [
                'No, but we plan to report our portfolio’s exposure to fossil fuel in the next two years',
                'No, and we do not plan to report our portfolio’s exposure to fossil fuel in the next two years'
              ]
            },
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q7_1_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'No, but we plan to report our portfolio’s exposure to fossil fuel in the next two years',
                'No, and we do not plan to report our portfolio’s exposure to fossil fuel in the next two years'
              ],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q7_8_VALUE,
            'Please explain why you are not providing values of the financing and/or insurance to fossil fuel assets',
            2500,
            undefined,
            undefined,
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q7_1_VALUE,
              condition: conditionType.NOT,
              values: [
                'No, but we plan to report our portfolio’s exposure to fossil fuel in the next two years',
                'No, and we do not plan to report our portfolio’s exposure to fossil fuel in the next two years'
              ]
            },
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q7_1_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'No, but we plan to report our portfolio’s exposure to fossil fuel in the next two years',
                'No, and we do not plan to report our portfolio’s exposure to fossil fuel in the next two years'
              ],
              required: true
            }
          )
        ]
      )
    ]
  },
  {
    key: 'Q8',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_FINANCIAL_SERVICES_KEYS.Q8_VALUE,
        '12.4 Does your organization provide finance and/or insurance to companies in the commodity value chain? If so, for each commodity and portfolio, state the values of your financing and/or insurance in the reporting year.',
        'The production of certain key agricultural commodities has caused more than 60% of forest loss in Latin America and Southeast Asia, usually resulting in a permanent loss. While not all commodity production is necessarily harmful, understanding the concentrations of commodityrelated assets in portfolios will enable financial institutions to understand where there is the potential for deforestation impacts and where enhanced policies are needed to prevent them.',
        'Financing and/or insurance of commodity',
        [
          {
            id: 'Lending to companies operating in the timber products value chain',
            label:
              'Lending to companies operating in the timber products value chain'
          },
          {
            id: 'Lending to companies operating in the palm oil value chain',
            label: 'Lending to companies operating in the palm oil value chain'
          },
          {
            id: 'Lending to companies operating in the cattle products value chain',
            label:
              'Lending to companies operating in the cattle products value chain'
          },
          {
            id: 'Lending to companies operating in the soy value chain',
            label: 'Lending to companies operating in the soy value chain'
          },
          {
            id: 'Lending to companies operating in the rubber value chain',
            label: 'Lending to companies operating in the rubber value chain'
          },
          {
            id: 'Lending to companies operating in the cocoa value chain',
            label: 'Lending to companies operating in the cocoa value chain'
          },
          {
            id: 'Lending to companies operating in the coffee value chain',
            label: 'Lending to companies operating in the coffee value chain'
          },
          {
            id: 'Investing (asset manager) in companies operating in the timber products value chain',
            label:
              'Investing (asset manager) in companies operating in the timber products value chain'
          },
          {
            id: 'Investing (asset manager) in companies operating in the palm oil value chain',
            label:
              'Investing (asset manager) in companies operating in the palm oil value chain'
          },
          {
            id: 'Investing (asset manager) in companies operating in the cattle products value chain',
            label:
              'Investing (asset manager) in companies operating in the cattle products value chain'
          },
          {
            id: 'Investing (asset manager) in companies operating in the soy value chain',
            label:
              'Investing (asset manager) in companies operating in the soy value chain'
          },
          {
            id: 'Investing (asset manager) in companies operating in the rubber value chain',
            label:
              'Investing (asset manager) in companies operating in the rubber value chain'
          },
          {
            id: 'Investing (asset manager) in companies operating in the cocoa value chain',
            label:
              'Investing (asset manager) in companies operating in the cocoa value chain'
          },
          {
            id: 'Investing (asset manager) in companies operating in the coffee value chain',
            label:
              'Investing (asset manager) in companies operating in the coffee value chain'
          },
          {
            id: 'Investing (asset owner) in companies operating in the timber products value chain',
            label:
              'Investing (asset owner) in companies operating in the timber products value chain'
          },
          {
            id: 'Investing (asset owner) in companies operating in the palm oil value chain',
            label:
              'Investing (asset owner) in companies operating in the palm oil value chain'
          },
          {
            id: 'Investing (asset owner) in companies operating in the cattle products value chain',
            label:
              'Investing (asset owner) in companies operating in the cattle products value chain'
          },
          {
            id: 'Investing (asset owner) in companies operating in the soy value chain',
            label:
              'Investing (asset owner) in companies operating in the soy value chain'
          },
          {
            id: 'Investing (asset owner) in companies operating in the rubber value chain',
            label:
              'Investing (asset owner) in companies operating in the rubber value chain'
          },
          {
            id: 'Investing (asset owner) in companies operating in the cocoa value chain',
            label:
              'Investing (asset owner) in companies operating in the cocoa value chain'
          },
          {
            id: 'Investing (asset owner) in companies operating in the coffee value chain',
            label:
              'Investing (asset owner) in companies operating in the coffee value chain'
          },
          {
            id: 'Insuring companies operating in the timber products value chain',
            label:
              'Insuring companies operating in the timber products value chain'
          },
          {
            id: 'Insuring companies operating in the palm oil value chain',
            label: 'Insuring companies operating in the palm oil value chain'
          },
          {
            id: 'Insuring companies operating in the cattle products value chain',
            label:
              'Insuring companies operating in the cattle products value chain'
          },
          {
            id: 'Insuring companies operating in the soy value chain',
            label: 'Insuring companies operating in the soy value chain'
          },
          {
            id: 'Insuring companies operating in the rubber value chain',
            label: 'Insuring companies operating in the rubber value chain'
          },
          {
            id: 'Insuring companies operating in the cocoa value chain',
            label: 'Insuring companies operating in the cocoa value chain'
          },
          {
            id: 'Insuring companies operating in the coffee value chain',
            label: 'Insuring companies operating in the coffee value chain'
          }
        ],
        [
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q8_1_VALUE,
            'Finance or insurance provided to companies operating in the value chain for this commodity',
            YES_NO_UNKNOWN_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q8_2_VALUE,
            'Commodity value chain stage coverage',
            COMMODITY_VALUE_CHAIN_STAGE_COVERAGE_OPTIONS
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q8_3_VALUE,
            'Portfolio exposure (unit currency – as specified in 1.2)',
            2
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q8_4_VALUE,
            'New loans advanced in reporting year (unit currency – as specified in 1.2)',
            2
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q8_5_VALUE,
            'Total premium written in reporting year (unit currency – as specified in 1.2)'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q8_6_VALUE,
            '% value of the exposure in relation to your total portfolio value',
            1
          )
        ]
      )
    ]
  },
  {
    key: 'Q9',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_FINANCIAL_SERVICES_KEYS.Q9_VALUE,
        '12.5 In the reporting year, did your organization finance and/or insure activities or sectors that are aligned with, or eligible under, a sustainable finance taxonomy? If so, are you able to report the values of that financing and/or underwriting?',
        'Financial institutions need to ensure that their lending, investing and/or insurance is supporting the climate transition of the wider economy. An assessment of the financing and insuring of business activities or sectors defined as sustainable according to a sustainable finance taxonomy can inform progress on the organization’s commitment to mitigate and adapt to climate change, as well as add credibility to it.',
        'Portfolio',
        [
          {id: 'Banking (Bank)', label: 'Banking (Bank)'},
          {id: 'Investing (Asset manager)', label: 'Investing (Asset manager)'},
          {id: 'Investing (Asset owner)', label: 'Investing (Asset owner)'},
          {
            id: 'Insurance underwriting (Insurance company)',
            label: 'Insurance underwriting (Insurance company)'
          }
        ],
        [
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_1_VALUE,
            'Reporting values of the financing and/or insurance of activities or sectors that are eligible under or aligned with a sustainable finance taxonomy',
            PLAN_TO_DO_OPTIONS
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_2_VALUE,
            'Taxonomy under which portfolio alignment is being reported',
            TAXONOMY_OR_FRAMEWORK_USED_TO_DEFINE_GREEN_FINANCE_OPTIONS
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_3_VALUE,
            'Total assets in your portfolio (unit currency as selected in 1.2) [auto-calculated]',
            2
          ),

          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_4_VALUE,
            'Total assets covered in the calculation of the taxonomy KPIs in the reporting year',
            2
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_5_VALUE,
            'Total assets excluded from the calculation of your alignment KPIs in the reporting year',
            2
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_6_VALUE,
            'Aligned assets based on turnover of investees in the reporting year (unit currency as selected in 1.2)',
            2
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_7_VALUE,
            'Share of aligned assets based on turnover of investees out of total assets in the reporting year',
            1
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_8_VALUE,
            'Eligible assets based on turnover of investees in the reporting year'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_9_VALUE,
            'Share of eligible assets based on turnover of investees in the reporting year out of total assets in the reporting year',
            1
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_10_VALUE,
            'Aligned assets based on CAPEX of investees in the reporting year (unit currency as selected in 1.2)'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_11_VALUE,
            'Share of aligned assets based on CAPEX of investees out of total assets in the reporting year',
            1
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_12_VALUE,
            'Eligible assets based on CAPEX of investees in the reporting year'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_13_VALUE,
            'Share of eligible assets based on CAPEX of investees out of total assets in the reporting year',
            1
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_14_VALUE,
            'Share of aligned assets contributing to climate change mitigation based on turnover of investees in the reporting year',
            1
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_15_VALUE,
            'Share of aligned assets contributing to climate change mitigation that is transitional based on turnover of investees in the reporting year'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_16_VALUE,
            'Share of aligned assets contributing to climate change mitigation that is enabling based on turnover of investees in the reporting year',
            1
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_17_VALUE,
            'Share of aligned assets contributing to climate change adaptation based on turnover of investees in the reporting year',
            1
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_18_VALUE,
            'Share of aligned assets contributing to climate change adaptation that is adapted based on turnover of investees in the reporting year',
            1
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_19_VALUE,
            'Share of aligned assets contributing to climate change adaptation that is enabling based on turnover of investees in the reporting year',
            1
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_20_VALUE,
            'Share of aligned assets contributing to climate change mitigation based on CAPEX of investees in the reporting year',
            1
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_21_VALUE,
            'Share of aligned assets contributing to climate change mitigation that is transitional based on CAPEX of investees in the reporting year',
            1
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_22_VALUE,
            'Share of aligned assets contributing to climate change mitigation that is enabling based on CAPEX of investees in the reporting year',
            1
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_23_VALUE,
            'Share of aligned assets contributing to climate change adaptation based on CAPEX of investees in the reporting year',
            1
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_24_VALUE,
            'Share of aligned assets contributing to climate change adaptation that is adapted based on CAPEX of investees in the reporting year',
            1
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_25_VALUE,
            'Share of aligned assets contributing to climate change adaptation that is enabling based on CAPEX of investees in the reporting year',
            1
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_26_VALUE,
            'Total assets aligned with the taxonomy in the reporting year'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_27_VALUE,
            '% of portfolio that is aligned with the taxonomy in the reporting year',
            1
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_28_VALUE,
            'Description of assets excluded from alignment calculation and reasons for exclusion'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_29_VALUE,
            'Total premium written in reporting year (unit currency – as specified in 1.2)'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_30_VALUE,
            'Gross premiums written for taxonomy-aligned non-life insurance and reinsurance activities'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_31_VALUE,
            'Total premiums written'
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_32_VALUE,
            '“Do No Significant Harm” requirements met',
            YES_NO_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_33_VALUE,
            'Details of “Do No Significant Harm” analysis'
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_34_VALUE,
            'Details of calculation'
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_35_VALUE,
            'Primary reason for not providing values of the financing and/or insurance',
            PRIMARY_REASON_FOR_NOT_PROVIDING_VALUES_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q9_36_VALUE,
            'Explain why you are not providing values of the financing and/or insurance'
          )
        ]
      )
    ]
  },
  {
    key: 'Q10',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FINANCIAL_SERVICES_KEYS.Q10_VALUE,
        '12.6 Do any of your existing products and services enable clients to mitigate and/or adapt to the effects of',
        'Achieving a 1.5°C, deforestation-free and conversion-free, water-secure world will require massive investment in low-carbon technologies, sustainable land use, and sustainable agricultural and water management practices. Data users are interested in whether financial institutions are providing financial products and services to meet this investment challenge. This question is useful to investors seeking to increase their investment in organizations providing environmentally sustainable financial products and services.',
        [
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q10_1_VALUE,
            'Existing products and services enable clients to mitigate and/or adapt to the effects of environmental issues',
            PLAN_TO_DO_OPTIONS
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q10_2_VALUE,
            'Primary reason for not offering products and services that enable clients to mitigate and/or adapt to the effects of environmental issues',
            PRIMARY_REASON_FOR_NOT_PROVIDING_VALUES_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q10_3_VALUE,
            'Explain why your organization does not offer products and services that enable clients to mitigate and/or adapt to the effects of environmental issues',
            2500
          )
        ]
      )
    ]
  },
  {
    key: 'Q11',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FINANCIAL_SERVICES_KEYS.Q11_VALUE,
        '12.6.1 Provide details of your existing products and services that enable clients to mitigate and/or adapt to the effects of environmental issues, including any taxonomy or methodology used to classify the products and services.',
        'Achieving a 1.5°C, deforestation-free and conversion-free, water-secure world will require massive investment in low carbon technologies, sustainable land use, and sustainable agricultural and water management practices. Data users are interested in whether financial institutions are providing financial products and services to meet this investment challenge. This question is useful to investors seeking to increase their investment in organizations providing environmentally sustainable financial products and services. ',
        [
          createRowMultiSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q11_1_VALUE,
            'Environmental issue',
            ENVIRONMENTAL_ISSUES_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q11_2_VALUE,
            'Product/service enables clients to mitigate and/or adapt to climate change',
            MITIGATION_ADAPTATION_OPTIONS,
            true,
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q11_1_VALUE,
              condition: conditionType.NOT_INCLUDES,
              values: ['Climate change']
            },
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q11_1_VALUE,
              condition: conditionType.INCLUDES,
              values: ['Climate change'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q11_3_VALUE,
            'Portfolio',
            PORTFOLIOS_COVERED_BY_THE_TARGET_OPTIONS
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q11_4_VALUE,
            'Asset class',
            ASSET_CLASSES_COVERED_BY_THE_TARGET_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q11_5_VALUE,
            'Type of product classification',
            TYPE_OF_PRODUCT_CLASSIFICATION_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q11_6_VALUE,
            'Taxonomy or methodology used to identify product characteristics',
            TAXONOMY_OR_METHODOLOGY_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q11_7_VALUE,
            'Type of solution financed, invested in or insured',
            TYPE_OF_SOLUTION_FINANCED_INVESTED_INSURED_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q11_8_VALUE,
            'Description of product/service',
            2500
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q11_9_VALUE,
            '% of portfolio aligned with a taxonomy or methodology in relation to total portfolio value',
            3
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q11_10_VALUE,
            '% of asset value aligned with a taxonomy or methodology',
            3
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q11_11_VALUE,
            'Product considers principal adverse impacts on environmental factors',
            YES_NO_OPTIONS,
            true,
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q11_5_VALUE,
              condition: conditionType.NOT_INCLUDES,
              values: [
                'Products that promote environmental and/or social characteristics',
                'Products that have sustainable investment as their core objective'
              ]
            },
            {
              fieldName: CDP_FINANCIAL_SERVICES_KEYS.Q11_5_VALUE,
              condition: conditionType.INCLUDES,
              values: [
                'Products that promote environmental and/or social characteristics',
                'Products that have sustainable investment as their core objective'
              ],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q11_12_VALUE,
            'Details on how the principal adverse impacts on environmental factors are considered in this product',
            2500
          )
        ],
        true,
        CDP_FINANCIAL_SERVICES_KEYS.Q10_VALUE,
        CDP_FINANCIAL_SERVICES_KEYS.Q10_1_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q12',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_FINANCIAL_SERVICES_KEYS.Q12_VALUE,
        '12.7 Has your organization set targets for deforestation and conversion-free and/or water-secure lending, investing and/or insuring.',
        'Target setting plays a vital role in environmental action through its role in the successful execution of organizations’ strategies, as well as in the effective management of dependencies, impacts, risks, and opportunities. Your response to this question signals to data users your commitment to environmental action by setting targets for deforestation-free and conversionfree and/or water secure lending, investing and/or insuring. Financial services companies set and progress targets for deforestation-free and conversion-free and/or water secure lending, investing and/or insuring.',
        'Environmental issue',
        [
          {id: 'Forests', label: 'Forests'},
          {id: 'Water', label: 'Water'}
        ],
        [
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q12_1_VALUE,
            'Target set',
            TARGET_SET_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q12_2_VALUE,
            'Explain why your organization has not set targets for deforestation- and conversion-free and/or water-secure lending, investing and/or insuring',
            2500
          )
        ]
      )
    ]
  },
  {
    key: 'Q13',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_FINANCIAL_SERVICES_KEYS.Q13_VALUE,
        '12.7.1 Provide details of your targets for deforestation and conversion free and/or water-secure lending,',
        'Target setting plays a vital role in environmental action through its role in the successful execution of corporate strategies, as well as in the effective management of dependencies, impacts, risks, and opportunities. Your response to this question indicates to data users your commitment to environmental action by providing details of your targets for deforestation and conversion free and/or water secure lending, investing and/or insuring.',
        'Environmental issue covered by the target',
        [
          {id: 'Forests', label: 'Forests'},
          {id: 'Water', label: 'Water'}
        ],
        [
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q13_1_VALUE,
            'Portfolio',
            PORTFOLIOS_COVERED_BY_THE_TARGET_OPTIONS
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q13_2_VALUE,
            'Targets set',
            TARGET_SET_FULL_OPTIONS
          ),
          createRowDatePickerField(
            CDP_FINANCIAL_SERVICES_KEYS.Q13_3_VALUE,
            'Date target was set'
          ),
          createRowMultiSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q13_4_VALUE,
            'Sectors covered by the target',
            INDUSTRY_SECTORS_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q13_5_VALUE,
            'Asset classes covered by the target',
            ASSET_CLASSES_COVERED_BY_THE_TARGET_OPTIONS
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q13_6_VALUE,
            'The target has been set with reference to',
            NATURE_TARGET_SETTING_REFERENCES_OPTIONS
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q13_7_VALUE,
            '% of portfolio covered by the target in relation to total portfolio value'
          ),
          createRowSelectField(
            CDP_FINANCIAL_SERVICES_KEYS.Q13_8_VALUE,
            'Target metric',
            METRIC_TYPE_OPTIONS
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q13_9_VALUE,
            'Target value'
          ),
          createRowDatePickerField(
            CDP_FINANCIAL_SERVICES_KEYS.Q13_10_VALUE,
            'End date of target'
          ),
          createRowDatePickerField(
            CDP_FINANCIAL_SERVICES_KEYS.Q13_11_VALUE,
            'End date of base year'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q13_12_VALUE,
            'Figure in base year'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q13_13_VALUE,
            'Figure in reporting year'
          ),
          createRowNumberField(
            CDP_FINANCIAL_SERVICES_KEYS.Q13_14_VALUE,
            '% of target achieved'
          ),
          createRowWysiwygField(
            CDP_FINANCIAL_SERVICES_KEYS.Q13_15_VALUE,
            'Provide details of the target',
            2500
          )
        ]
      )
    ]
  }
];
